import { render, staticRenderFns } from "./SectionDivisionList.vue?vue&type=template&id=396e81bc&scoped=true&"
import script from "./SectionDivisionList.vue?vue&type=script&lang=js&"
export * from "./SectionDivisionList.vue?vue&type=script&lang=js&"
import style0 from "./SectionDivisionList.vue?vue&type=style&index=0&id=396e81bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e81bc",
  null
  
)

export default component.exports